/**
 * Platform detection utilities for web app
 */

export interface PlatformInfo {
  isIOS: boolean;
  isAndroid: boolean;
  isMobile: boolean;
  platform: 'ios' | 'android' | 'desktop';
}

/**
 * Detect user's platform based on user agent
 */
export const detectPlatform = (): PlatformInfo => {
  const userAgent = navigator.userAgent;
  
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const isMobile = isIOS || isAndroid;
  
  let platform: 'ios' | 'android' | 'desktop' = 'desktop';
  if (isIOS) {
    platform = 'ios';
  } else if (isAndroid) {
    platform = 'android';
  }
  
  return {
    isIOS,
    isAndroid,
    isMobile,
    platform
  };
};

/**
 * Get the appropriate app download link based on platform
 */
export const getAppDownloadLink = (platform: PlatformInfo) => {
  if (platform.isIOS) {
    return {
      url: 'https://testflight.apple.com/join/X1uaaAVz',
      text: 'Join iOS Beta',
      buttonText: 'Join Beta',
      fullButtonText: 'Join iOS Beta Testing',
      description: 'Help us test new features!',
      rating: 'Beta Testing',
      icon: 'testflight'
    };
  } else if (platform.isAndroid) {
    return {
      url: 'https://play.google.com/store/apps/details?id=com.poptheballoon',
      text: 'Get the App!',
      buttonText: 'Download',
      fullButtonText: 'Download on Google Play',
      description: '4.5★ rating • Free download',
      rating: '4.5★ rating • Free download',
      icon: 'googleplay'
    };
  }
  
  // Default fallback (shouldn't be used since banner only shows on mobile)
  return {
    url: 'https://play.google.com/store/apps/details?id=com.poptheballoon',
    text: 'Download the Mobile App',
    buttonText: 'Download',
    fullButtonText: 'Download App',
    description: 'Available on mobile devices',
    rating: 'Available on mobile',
    icon: 'googleplay'
  };
};